export default {
  queued: "blue",
  sent: "blue",
  failed: "red",
  delivered: "green",
  undelivered: "red",
  rejected: "red",
  i: "royalblue"
};
